import { render, staticRenderFns } from "./RadarChart.vue?vue&type=template&id=5bec1694&scoped=true&"
import script from "./RadarChart.vue?vue&type=script&lang=ts&"
export * from "./RadarChart.vue?vue&type=script&lang=ts&"
import style0 from "./RadarChart.vue?vue&type=style&index=0&id=5bec1694&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec1694",
  null
  
)

export default component.exports